export default __webpack_public_path__ + "static/media/murder-mystery-desktop.ad09a3b8.mp4";